var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMapMarkerKeyline = function SvgIconMapMarkerKeyline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.356 19.174a44.345 44.345 0 0 0 2.353-2.783c.815-1.052 1.512-2.069 2.056-3.022C17.572 11.96 18 10.753 18 9.857 18 6.407 15.271 4 12 4S6 6.408 6 9.857c0 .896.429 2.101 1.235 3.512.544.953 1.241 1.97 2.056 3.022A44.36 44.36 0 0 0 12 19.56c.114-.122.233-.25.356-.385ZM20 9.857c0 1.315-.535 2.818-1.498 4.504-.595 1.042-1.344 2.134-2.211 3.255a46.376 46.376 0 0 1-3.587 4.094 1 1 0 0 1-1.408 0 44.493 44.493 0 0 1-1.127-1.185 46.372 46.372 0 0 1-2.46-2.91c-.867-1.12-1.616-2.212-2.211-3.254C4.535 12.675 4 11.171 4 9.857 4 5.244 7.676 2 12 2s8 3.244 8 7.857Zm-9.414 1.557a2 2 0 1 1 2.828-2.828 2 2 0 0 1-2.828 2.828Z",
    fill: "#051E2A"
  })));
};
export default SvgIconMapMarkerKeyline;